import './styles/EmptyData.scss';

import { ChartBar, ClipboardText } from '@phosphor-icons/react';
import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from '../../Card';
import { Heading, Levels } from '../../Typography';

const componentName = 'c-EmptyData';

interface Props {
  type?: 'graph' | 'table';
  boxShadow?: boolean;
  headingLevel?: Levels;
  iconSize?: number;
  boxHeight?: number;
  customWrapperComponent?: React.ComponentType<{
    boxShadow: boolean;
    children?: React.ReactNode;
  }> | null;
  color?: string;
}

export const EmptyData = ({
  type = 'graph',
  boxShadow = true,
  headingLevel = 3 as Levels,
  iconSize = 64,
  boxHeight = 360,
  color = 'var(--border-color-base)',
  customWrapperComponent = Card,
}: Props) => {
  const { t } = useTranslation();

  const Icon = type === 'graph' ? ChartBar : ClipboardText;

  const content = (
    <div
      className={componentName}
      style={{ '--box-height': `${boxHeight}px` } as CSSProperties}
    >
      <div>
        <Icon size={iconSize} color={color} />
        <Heading
          level={headingLevel}
          style={{ color: color }}
          className="text-center"
        >
          {t('reportsPage_noData_Graph')}
        </Heading>
      </div>
    </div>
  );

  if (customWrapperComponent === null) {
    return <div>{content}</div>;
  }

  const CustomWrapperComponent = customWrapperComponent;

  return (
    <CustomWrapperComponent boxShadow={boxShadow}>
      {content}
    </CustomWrapperComponent>
  );
};
